import { render, staticRenderFns } from "./TransactionDetails.vue?vue&type=template&id=8c577086&scoped=true"
import script from "./TransactionDetails.vue?vue&type=script&lang=ts"
export * from "./TransactionDetails.vue?vue&type=script&lang=ts"
import style0 from "./card.less?vue&type=style&index=0&id=8c577086&prod&lang=less&scoped=true&external"
import style1 from "./TransactionDetails.vue?vue&type=style&index=1&id=8c577086&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c577086",
  null
  
)

export default component.exports